import { SvgIcon, type SvgIconProps } from "@mui/material";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";

const [width, height, , , path] = faBoxOpen.icon;

// Same glyph as the Orders side nav item, wrapped so it accepts MUI icon props.
export function OrdersBoxIcon(props: Readonly<SvgIconProps>) {
  return (
    <SvgIcon viewBox={`0 0 ${width} ${height}`} {...props}>
      <path d={path as string} />
    </SvgIcon>
  );
}
